interface BlogData {
  id: string;
  title: string;
  blogText?: string;
  date?: string;
  isShortText?: boolean;
}

const READ_MORE_CHAR_LENGTH = 80;

interface Props {
  key: string;
  data: BlogData;
}

export const BlogContentTile = ({ data, key }: Props) => {
  return (
    <div className="p-6 bg-slate-800 rounded-xl mb-5" key={key}>
      <div className="border-b border-gray-600 py-2 flex w-full justify-between">
        <h4>
          {data.title} {data.id}
        </h4>
        <span>Date: {data.date}</span>
      </div>
      <div className="flex w-full pt-5">
        {data.isShortText && data.blogText.length > READ_MORE_CHAR_LENGTH ? (
          <p>{data.blogText.substring(0, READ_MORE_CHAR_LENGTH)}...</p>
        ) : (
          <p>{data.blogText}</p>
        )}
        {data.isShortText && data.blogText.length > READ_MORE_CHAR_LENGTH && (
          <button className="rounded-3xl border-white hover:border-gray-200 hover:text-gray-200 font-bold border-2 p-2 mt-5 ml-auto">
            Read more
          </button>
        )}
      </div>
    </div>
  );
};
